<div class="portal--header">
    <h1 class="heading">PAYG portfolio</h1>
</div>
<div class="portal--main">
    <div class="flex-grid end stack-sm">
        <div class="flex-grid--item organise-select">
            <label for="">Site:</label>
            <select name="siteId" id="" class="select__standalone" [(ngModel)]="selectedSiteId" (change)="updateSite()" #siteId>
                <option [ngValue]="0">All</option>
                <option [ngValue]="site.siteId" *ngFor="let site of sites">{{site.siteName}}</option>
            </select>
        </div>
    </div>
    <div class="module drop-shadow bottom summary__module six">
        <div class="module--main third">
            <div class="block-num text-center">
                <svg class="ic"><use xlink:href="#ic-consumers" href="#ic-consumers"></use></svg>
                <h2 class="subheading-sm">Total PAYG consumers</h2>
                <ng-container *ngIf="paygSummary != undefined; else noDataConsumers">
                    <span class="lg">
                        {{paygSummary.paygproperties}}
                        <svg *ngIf="isIncreasing" class="ic-arrow"><use xlink:href="#ic-arrow-up" href="#ic-arrow-up"></use></svg>
                        <svg *ngIf="isDecreasing" class="ic-arrow"><use xlink:href="#ic-arrow-down" href="#ic-arrow-down"></use></svg>
                    </span>
                    <span>Equates to {{paygConsumersPercentage}}% of your consumers</span>
                    <span *ngIf="paygSummary.paygPropertiesChange != 0">
                        <span *ngIf="isIncreasing">Up by {{paygSummary.paygpropertiesChange }} from the end of the last calendar month</span>
                        <span *ngIf="isDecreasing">Down by {{paygSummary.paygpropertiesChange }} from the end of the last calendar month</span>
                    </span>
                </ng-container>
                <ng-template #noDataConsumers>
                    <p>No data available</p>
                </ng-template>
            </div>
        </div>
        <div class="module--main third">
            <div class="block-num text-center">
                <svg class="ic"><use xlink:href="#ic-tenancy-change" href="#ic-tenancy-change"></use></svg>
                <h2 class="subheading-sm">Change of tenancies</h2>
                <div class="summary__module--flex" *ngIf="paygSummary != undefined; else noDataChangeTenancy">
                    <div class="flex--item">
                        <span class="lg">{{paygSummary.cotLastMonth}}</span>
                        <span>last calendar month</span>
                    </div>
                    <div class="flex--item">
                        <span class="lg">{{paygSummary.cotThisMonth}}</span>
                        <span>current month to date</span>
                    </div>
                </div>
                <ng-template #noDataChangeTenancy>
                    <p>No data available</p>
                </ng-template>
            </div>
        </div>
        <div class="module--main third">
            <div class="block-num text-center">
                <svg class="ic"><use xlink:href="#ic-users-web-portal" href="#ic-users-web-portal"></use></svg>
                <h2 class="subheading-sm">consumers registered to my.switch2.co.uk</h2>
                <span class="lg" *ngIf="websiteUsersPercentage; else noDataConsumersRegistered">{{websiteUsersPercentage}}%</span>
                <ng-template #noDataConsumersRegistered>
                    <p>No data available</p>
                </ng-template>
            </div>
        </div>
        <div class="module--main third">
            <div class="block-num text-center">
                <svg class="ic"><use xlink:href="#ic-coins" href="#ic-coins"></use></svg>
                <h2 class="subheading-sm">Total portfolio credit status</h2>
                <div class="summary__module--flex" *ngIf="paygSummary; else noDataCreditStatus">
                    <div class="flex--item">
                        <span class="lg">{{paygSummary.creditStatusBalanceLastMonth | currency:'GBP'}}</span>
                        <span>last calendar month</span>
                    </div>
                    <div class="flex--item">
                        <span class="lg">{{paygSummary.creditStatusBalanceThisMonth | currency:'GBP'}}</span>
                        <span>current month to date</span>
                    </div>
                </div>
                <ng-template #noDataCreditStatus>
                    <p>No data available</p>
                </ng-template>
            </div>
        </div>
        <div class="module--main third">
            <div class="block-num text-center">
                <svg class="ic"><use xlink:href="#ic-payment" href="#ic-payment"></use></svg>
                <h2 class="subheading-sm">Average payment value</h2>
                <div class="summary__module--flex" *ngIf="paygSummary; else noDataAveragePayment">
                    <div class="flex--item">
                        <span class="lg">{{paygSummary.avgPaymentLastMonth | currency:'GBP'}}</span>
                        <span>last calendar month</span>
                    </div>
                    <div class="flex--item">
                        <span class="lg">{{paygSummary.avgPaymentThisMonth | currency:'GBP'}}</span>
                        <span>current month to date</span>
                    </div>
                </div>
                <ng-template #noDataAveragePayment>
                    <p>No data available</p>
                </ng-template>
            </div>
        </div>
        <div class="module--main third">
            <div class="block-num text-center">
                <svg class="ic"><use xlink:href="#ic-time" href="#ic-time"></use></svg>
                <h2 class="subheading-sm">Average payment Transmission time (minutes)</h2>
                <div class="summary__module--flex" *ngIf="paygSummary; else noDataAverageTransmissionTime">
                    <div class="flex--item">
                        <span class="lg">{{paygSummary.avgPaymentTimeLastMonth}}</span>
                        <span>last calendar month</span>
                    </div>
                    <div class="flex--item">
                        <span class="lg">{{paygSummary.avgPaymentTimeThisMonth}}</span>
                        <span>current month to date</span>
                    </div>
                </div>
                <ng-template #noDataAverageTransmissionTime>
                    <p>No data available</p>
                </ng-template>
            </div>
        </div>
    </div>
    <hr>
    <div class="flex-grid end stack-sm">
        <div class="flex-grid--item organise-select">
            <label for="">View:</label>
            <select name="timePeriod" id="" class="select__standalone" (change)="updateTimeperiod($event.target.value)" #timePeriod>
                <option value="12" selected>Last 12 months</option>
                <option value="6">Last 6 months</option>
                <option value="3">Last 3 months</option>
                <option value="2">Last 2 months</option>
                <option value="1">Last month</option>
            </select>
        </div>
    </div>
    <masonry [masonryItems]="masonryItems" [masonryColumnCount]="2"></masonry>
</div>
